
//Funciones para calcular valor PV60
//Falta factorizar y colocarlo mas generico, validar para menos de 30 años

const p = (i, rate, year) =>  (i /( Math.pow(1 + rate, year))); //Saca ek facor de descuento
const pvPartial = (years, value, initialValue, t, bi, ) =>{
  let lastBi = bi; let acc = initialValue;
  for (let i = 1; i <= years; i++) {
    lastBi = p(bi, t, i);
    acc += value * lastBi;    
  }
  return [lastBi, acc];
}

export const pv = (years, value, t0, t30) =>{
  const [lastBi, acc] = pvPartial(30, value, value, t0, 1);
  const res = pvPartial(years - 30, value, acc, t30, lastBi);
  return res[1];
}


/* Example */
// const years = 60;
// const value = 129009.6;
// console.log("Total2:", pv(years, value, 0.035, 0.030));